const ChecklistItemsTableColumnId = {
  NAME: 'name',
  DETERMINATION: 'calculations.expressionResult',
  RESULT: 'calculations.result',
  WAS_OVERRIDEN: 'calculations.wasOverriden',
};

export const checklistItemsTableColumns = [
  {
    id: ChecklistItemsTableColumnId.NAME,
    align: 'left',
    disablePadding: false,
    label: 'Item Name',
  },
  {
    id: ChecklistItemsTableColumnId.DETERMINATION,
    align: 'left',
    disablePadding: false,
    label: 'Determination',
  },
  {
    id: ChecklistItemsTableColumnId.RESULT,
    align: 'left',
    disablePadding: false,
    label: 'Result',
  },
  {
    id: ChecklistItemsTableColumnId.WAS_OVERRIDEN,
    align: 'left',
    disablePadding: false,
    label: 'Override',
  },
];

export const INDENT_PER_NESTING_LEVEL_PX = 16;
